import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDashboard } from './dashboardSlice';
import { selectIsIncarnated, selectIsLoggedIn, selectAuthStatus } from '../auth/authSlice';
import { selectFeatures } from '../settings/settingsSlice';
import CreateCourseModel from '../course/components/CreateCourseModel';
import DashboardContentOld from './DashboardContentOld';
import DashboardContent from './DashboardContent';
import { STATUS_LOADING, STATUS_SUCCEEDED } from '../../utils/constants';

const Dashboard = () => {
  const dispatch = useDispatch();

  const features = useSelector(selectFeatures);
  const isIncarnated = useSelector(selectIsIncarnated);
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const authStatus = useSelector(selectAuthStatus);

  const [searchQuery, setSearchQuery] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showNewDashboard, setShowNewDashboard] = useState(false);
  const [sortMode, setSortMode] = useState(false);

  useEffect(() => {
    if(features?.newDashboard)
      setShowNewDashboard(features?.newDashboard)
  }, [features?.newDashboard]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {    
    if (isLoggedIn && (authStatus === STATUS_SUCCEEDED || authStatus !== STATUS_LOADING)) {
      dispatch(fetchDashboard({ sortBy: sortMode ? 'created' : 'lastVisit', filters: [{ mode: 'name', value: searchQuery }] }));
    } else {
      // console.log('[Dashboard useEffect] User is NOT logged in or auth status is loading, NOT dispatching fetchDashboard.');
    }
  }, [dispatch, searchQuery, isIncarnated, sortMode, isLoggedIn, authStatus]);

  const openModal = () =>
    setIsModalOpen(true);
  
  const closeModal = () =>
    setIsModalOpen(false);
  
  const clearSearch = useCallback(() => {
    setSearchQuery('')
  }, []);

  const handleSearch = useCallback((value) => {
    setSearchQuery(value)
  }, []);
  
  return (<>
    { showNewDashboard
      ? <DashboardContent
          openModal={openModal} 
          handleSearch={handleSearch} 
          searchQuery={searchQuery} 
          clearSearch={clearSearch}
        />
      : <DashboardContentOld 
          openModal={openModal} 
          setSortMode={setSortMode}
          handleSearch={handleSearch}
          searchQuery={searchQuery} 
          clearSearch={clearSearch} 
        />
    }
    <CreateCourseModel open={isModalOpen} onClose={closeModal} /> 
  </>
  );
};

export default Dashboard;
